import type { RefObject } from "react";
import type { SlashSkillCompletionState } from "../../hooks/useSlashSkills";
import { GhostText } from "./GhostText";
import { SlashSkillMenu } from "./SlashSkillMenu";

type Props = {
  textareaRef: RefObject<HTMLTextAreaElement | null>;
  value: string;
  isTextareaFocused: boolean;
  completion: SlashSkillCompletionState;
};

export function SlashSkillCompletion({
  textareaRef,
  value,
  isTextareaFocused,
  completion,
}: Props) {
  return (
    <>
      <GhostText
        textareaRef={textareaRef}
        value={value}
        caret={completion.caret}
        suffix={completion.suffix}
      />
      {isTextareaFocused &&
        completion.token &&
        completion.matches.length > 0 && (
          <SlashSkillMenu
            textareaRef={textareaRef}
            value={value}
            slashStart={completion.token.start}
            skills={completion.matches}
            selectedIndex={completion.selectedIndex}
            onSelect={completion.onSelect}
          />
        )}
    </>
  );
}
